/**
 * access-token
 *
 * @desc 描述：账号 token
 * @desc 描述：使用 localStorage 持久化
 */

/* =================================================== */

import { proxy, subscribe } from 'valtio';

// 存储 key
export const ACCESS_TOKEN_KEY = '_accessToken_';

const initialState = {
  value: '',
};

export const accessTokenStore = proxy(JSON.parse(localStorage.getItem(ACCESS_TOKEN_KEY)!) || initialState);

subscribe(accessTokenStore, () => {
  localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(accessTokenStore));
});

/**
 * 清除 token
 */
export const clearAccessToken = () => {
  accessTokenStore.value = '';
};

/**
 * 设置 token
 */
export const setAccessToken = (token: string) => {
  accessTokenStore.value = token;
};
